/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Open_ProjectInputs */



/**
* | output |
* | --- |
* | "Open Project..." |
*
* @param {Open_ProjectInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const open_project = /** @type {((inputs?: Open_ProjectInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Open_ProjectInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ouvrir un projet...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Projekt öffnen...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Apri progetto...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Открытый проект...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Proyecto abierto...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("开放项目...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロジェクトを開く...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ओपन प्रोजेक्ट...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Projeto aberto...")
	return /** @type {LocalizedString} */ ("Open Project...")
});